/* eslint-disable */
export const listPublicAlumniProfiles = /* GraphQL */ `
  query PublicAlumniProfiles(
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicAlumniProfiles(
      publicProfile: x
      sortDirection: ASC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
      }
      nextToken
    }
  }
`;

export const listAlumniProfiles = /* GraphQL */ `
  query ListAlumniProfiles(
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlumniProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
      }
      nextToken
    }
  }
`;

export const alumniProfilesByOwner = /* GraphQL */ `
  query AlumniProfilesByOwner(
    $owner: String
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alumniProfilesByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        occupation
        headline
        experiences {
          startsAt {
            day
            month
            year
          }
          endsAt {
            day
            month
            year
          }
          company
          title
          description
          location
          logoUrl
        }
        educations {
          startsAt {
            day
            month
            year
          }
          endsAt {
            day
            month
            year
          }
          fieldOfStudy
          degreeName
          school
          description
          logoUrl
        }
        certifications {
          startsAt {
            day
            month
            year
          }
          endsAt {
            day
            month
            year
          }
          url
          name
          licenseNumber
          displaySource
          authority
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
